import React from 'react';
import { iphoneAppDownload, androidAppDownload } from '../../link-actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTabletAlt,
    faLaptop,
    faMobileAlt,
    faArrowCircleRight,
    faRedo,
    faArrowDown,
} from '@fortawesome/free-solid-svg-icons';
import LogoText from '../../components/logoText';
import {LandingPage} from "./../LandingPage";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
export const AflKids = () => {
    let sportKey = "afl";

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

    return (<LandingPage
        sportKey={"afl"}
        //promo={{name:'Winter Special', expiry: '30 June 2025', code: 'WINTER25'}}
        //promo={{name:'Bye Round Bonus', expiry: '30 June 2025', code: 'BYEBONUS25'}}
        banner={
            <><section className="atf-about-area atf-section-padding atf-shape" style={{backgroundColor: 'white', borderTop: '10px solid var(--thm-black)'}}>
                <div className="container">
                    <div className="row clearfix align-self-center">

                        <div className="col-xl-7 col-lg-7 col-12 align-self-center">
                            <div className="atf-single-about-img text-center my-auto wow fadeIn" data-wow-duration="1s" data-wow-delay="0.3s" data-wow-offset="0">
                                <h2 className={"landing-heading-grow"} style={{ marginBottom: "20px" }}>The app that<br /><span style={{ color: "#999999" }}>helps</span> <span style={{ color: "yellowgreen" }}>kids</span><br /><span style={{ color: "#999999" }}>learn to</span> <span style={{ color: "yellowgreen" }}>kick</span></h2>

                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-5 col-12 align-self-center">
                            <img src={"./assets/img/afl/intro_kick.png"} alt={"Footy kick"}/>
                        </div>
                    </div>
                </div>
            </section>
            </>}

        content={

            <div>


                <section className="atf-section-padding" >
                    <div className="container">
                        <div className="row justify-content-center clearfix">
                            <div className="col-lg-6 col-12 text-center align-self-center">
                                <div>
                                    <h2 className={"landing-heading-grow"} style={{ marginTop: "5px", marginBottom: "10px"}}>Simply take a kick</h2>
                                    <p style={{ fontSize: "18px", margin: "5px 0 10px 0" }}>With <LogoText /> running on your phone</p>

                                </div>
                            </div>
                            <div className="col-lg-6 col-12 text-center align-self-center">
                                <img className="col-lg-6 col-12" src="./assets/img/afl/simply_kick.png" alt="Take a kick" />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="atf-section-padding" >
                    <div className="container">
                        <div className="row justify-content-center clearfix">
                            <div className="col-lg-6 col-12 text-center align-self-center">
                                <h2 className={"landing-heading-grow"} style={{ marginTop: "10px", marginBottom: "10px"}}><span style={{color:"#999999"}}>Then analyse your</span><br/> run up, grip, ball drop,<br /><span style={{color:"yellowgreen"}}>and more.</span></h2>
                                <p style={{ fontSize: "18px", margin: "5px 0 10px 0" }}><LogoText /> detects a kick,<br />then shows a delayed slow motion replay.</p>
                                <p style={{ fontSize: "18px", margin: "5px 0 10px 0" }}>Providing vital feedback for them to improve.</p>
                            </div>
                            <div className="col-lg-6 col-12 text-center align-self-center">
                                <div className="col-lg-6 col-12" style={{display: 'inline-block'}}>
                                    <Carousel
                                      swipeable={true}
                                      draggable={true}
                                      showDots={false}
                                      responsive={responsive}
                                      infinite={true}
                                      autoPlay={true}
                                      autoPlaySpeed={1000}
                                      keyBoardControl={true}
                                      customTransition="all .5"
                                      transitionDuration={500}
                                      containerClass="carousel-container"
                                      dotListClass="custom-dot-list-style"
                                      itemClass="carousel-item-padding-40-px"
                                    >
                                        <div><img src="./assets/img/afl/ball_drop.png" alt="Check ball drop" className="col-lg-8 col-10" /></div>
                                        <div><img src="./assets/img/afl/grip.png" alt="Watch replay" className="col-lg-8 col-10" /></div>
                                        <div><img src="./assets/img/afl/straight_leg.png" alt="Watch replay" className="col-lg-8 col-10" /></div>
                                    </Carousel>
                                    <img src="./assets/img/afl/analyse.png" alt="Analyse" style={{marginTop: '-55px'}} />
                                </div>

                            </div>


                        </div>

                    </div>
                </section>
                {1==2 &&
                <section className="atf-section-padding" >
                    <div className="container">
                        <div className="row justify-content-center clearfix">
                            <div className="col-12 text-center align-self-center">
                                <div style={{padding: '50px 10px 30px 10px'}}>
                                    <div className="row justify-content-center clearfix">
                                        <div className="col-12 text-center ">
                                            <p style={{ fontSize: "30px",
                                                lineHeight: '1.4',
                                                color: "white",
                                                background: 'var(--thm-black)',
                                                display: 'inline-block',
                                                width: '280px',
                                                height: '280px',
                                                borderRadius: '150px',
                                                paddingTop: '60px'}}>
                                                <LogoText light={true} /><br />
                                                provides fast visual feedback<br/>
                                                <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: '50px', marginTop: '5px' }}></FontAwesomeIcon>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <h2 style={{ fontSize:'30px', marginTop: '20px', lineHeight: "1.5"}}><span style={{color:"#999999"}}>So your kids can</span><br/>Watch, Learn, and Improve.</h2>
                                <h2 style={{ fontSize:'30px', marginTop: '5px', lineHeight: "1.5", color:'yellowgreen'}}>After every kick.</h2>
                                <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: '50px', marginTop: '25px', color:'var(--thm-black)' }}></FontAwesomeIcon>
                            </div>
                        </div>
                    </div>
                </section>}

                <section className="atf-section-padding" style={{backgroundColor: 'var(--thm-black)'}} >
                    <div className="container">
                        <div className="row justify-content-center clearfix">
                            <div className="col-12 text-center align-self-center">
                                <h2 style={{ fontSize: '30px',lineHeight: "1.5", color:"white"}}>Fast visual feedback</h2>
                                <h2 style={{ fontSize: '30px',lineHeight: "1.5", color:"yellowgreen", marginBottom: '10px'}}>for fast improvement</h2>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="atf-section-padding">
                    <div className="container">
                        <div className="row justify-content-center clearfix">
                            <div className="col-lg-6 col-12 text-center">
                                <div>
                                    <h2 style={{ fontSize: '30px',  lineHeight: "1.5", color:"var(--thm-black)", marginBottom: '10px', marginTop: '30px'}}>Ball drop</h2>
                                    <p style={{fontSize: '18px'}}>Use the "Live Replay" to ensure your child is dropping the ball correctly on to their foot and not throwing it in to the air first.</p>
                                    <img src="./assets/img/afl/ball_drop_2.png" alt="Check ball drop" className="col-lg-8 col-10" />
                                </div>
                            </div>

                            <div className="col-lg-6 col-12 text-center">
                                <div>
                                    <h2 style={{ fontSize: '30px', lineHeight: "1.5", color:"var(--thm-black)", marginBottom: '10px', marginTop: '30px'}}>Grip</h2>
                                    <p style={{fontSize: '18px'}}>A good kick starts with a good grip. Use "Mirror mode" for your child to discover how it feels to hold the ball properly.</p>
                                    <img src="./assets/img/afl/grip.png" alt="Watch replay" className="col-lg-8 col-10" />
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center clearfix">
                            <div className="col-lg-6 col-12 text-center">
                                <div>
                                    <h2 style={{ fontSize: '30px', lineHeight: "1.5", color:"var(--thm-black)", marginBottom: '10px', marginTop: '30px'}}>Straight follow through</h2>
                                    <p style={{fontSize: '18px'}}>Draw lines over the replay to check for a straight run up and follow through.</p>
                                    <img src="./assets/img/afl/straight_leg.png" alt="Watch replay" className="col-lg-8 col-10" />
                                </div>
                            </div>

                            <div className="col-lg-6 col-12 text-center">
                                <div>
                                    <h2 style={{ fontSize: '30px',  lineHeight: "1.5", color:"var(--thm-black)", marginBottom: '10px', marginTop: '30px'}}>Impact point</h2>
                                    <p style={{fontSize: '18px'}}>Pause the "Live replay" at impact to check the right part of the ball is being kicked for a nice drop punt.</p>
                                    <img src="./assets/img/afl/impact_point.png" alt="Impact point" className="col-lg-8 col-10" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="atf-section-padding" style={{backgroundColor: 'var(--thm-black)'}} >
                    <div className="container">
                        <div className="row justify-content-center clearfix">
                            <div className="col-12 text-center align-self-center">
                                <h2 style={{ fontSize: '30px',lineHeight: "1.5", color:"white", marginBottom: '10px'}}>Don't tell them how to kick. <span style={{color: 'yellowgreen'}}>Show them.</span></h2>

                                <p style={{fontSize: '14px', marginTop: '20px', color:"white"}}>Try 7 days for free</p>
                                <div>
                                    <a href="#" onClick={() => iphoneAppDownload(`${sportKey}_video_mid`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                    <a href="#" onClick={() => androidAppDownload(`${sportKey}_video_mid`)} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section className="atf-section-padding">
                    <div className="container">
                        <div className="row justify-content-center clearfix">
                            <div className="col-lg-6 col-12 text-center">
                                    <h2 style={{ fontSize: '30px',  lineHeight: "1.5", color:"var(--thm-black)", marginBottom: '10px', marginTop: '30px'}}>Pause the replay</h2>
                                    <p style={{fontSize: '18px'}}>Pause the replay and scroll back and forward through time for detailed analysis.</p>
                                    <div>
                                    <Carousel
                                      swipeable={true}
                                      draggable={true}
                                      showDots={false}
                                      responsive={responsive}
                                      infinite={true}
                                      autoPlay={true}
                                      autoPlaySpeed={400}
                                      keyBoardControl={true}
                                      customTransition="all .5"
                                      transitionDuration={500}
                                      containerClass="carousel-container"
                                      dotListClass="custom-dot-list-style"
                                      itemClass="carousel-item-padding-40-px"
                                    >
                                        <img src="./assets/img/afl/pause_replay_1.png" alt="Pause replay" className="col-lg-6 col-9" />
                                        <img src="./assets/img/afl/pause_replay_2.png" alt="Pause replay" className="col-lg-6 col-9" />
                                        <img src="./assets/img/afl/pause_replay_3.png" alt="Pause replay" className="col-lg-6 col-9" />
                                        <img src="./assets/img/afl/pause_replay_4.png" alt="Pause replay" className="col-lg-6 col-9" />
                                    </Carousel>
                                    </div>
                            </div>

                            <div className="col-lg-6 col-12 text-center">
                                <div>
                                    <h2 style={{ fontSize: '30px', lineHeight: "1.5", color:"var(--thm-black)", marginBottom: '10px', marginTop: '30px'}}>Cast to tablet or laptop</h2>
                                    <p style={{fontSize: '18px', marginBottom: '20px'}}>Connect a tablet or laptop and watch the replay on a bigger screen, from any angle.</p>
                                    <img src="./assets/img/afl/connect_device.png" alt="Cast to second device" className="col-lg-9 col-10" />
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center clearfix">
                            <div className="col-lg-6 col-12 text-center">
                                <div>
                                    <h2 style={{ fontSize: '30px', lineHeight: "1.5", color:"var(--thm-black)", marginBottom: '10px', marginTop: '30px'}}>Draw lines</h2>
                                    <p style={{fontSize: '18px', marginBottom: '20px'}}>Add guides to show your child where a correct position is.  They can then compare, after every kick.</p>
                                    <img src="./assets/img/afl/draw_lines.png" alt="Draw lines" className="col-10" />
                                </div>
                            </div>

                            <div className="col-lg-6 col-12 text-center">
                                <div>
                                    <h2 style={{ fontSize: '30px',  lineHeight: "1.5", color:"var(--thm-black)", marginBottom: '10px', marginTop: '30px'}}>Virtual mirror</h2>
                                    <p style={{fontSize: '18px', marginBottom: '20px'}}>Enter "Mirror mode" by setting the delay to zero. It works like a real mirror but you can take it to the park.</p>
                                    <img src="./assets/img/afl/mirror.png" alt="Virtual mirror" className="col-10" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <section className="atf-setup-area atf-section-padding">
                    <div className="container">
                        <div className="row clearfix align-self-center">
                            <div className="col-xl-7 col-lg-7 col-12 align-self-center">
                                <div className="atf-single-about-img text-center my-auto">
                                    <h2 style={{ margin: '20px 10px 5px 10px', fontSize: '30px', lineHeight: "1.5", color: "var(--thm-black)"}}>Kids know what a<br />good kick looks like.</h2>
                                    <h2 style={{ margin: '20px 10px 10px 10px', fontSize: '30px', lineHeight: "1.5", color: "yellowgreen"}}>They just don't realise<br />what <span style={{color: '#999999'}}>their</span> kick looks like.</h2>

                                    <p style={{ fontSize: "16px", marginTop: "25px" }}>Give them this awareness and they will both embrace what you're trying to teach them, and have a tool to practice by themselves.</p>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-5 col-12 align-self-center">
                                <div className="atf-single-about-img text-center my-auto wow fadeIn" data-wow-duration="1s" data-wow-delay="0.3s" data-wow-offset="0">
                                    <img src={"./assets/img/afl/grace_kick.png"}  alt={"Footy kick"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="atf-section-padding">
                    <div className="container">
                        <div className="row justify-content-center" style={{backgroundColor: "var(--thm-black)"}}>
                            <div className="col-xl-7 col-lg-7 col-12 align-self-center">
                                <div className="atf-single-about-img text-center my-auto wow fadeIn" data-wow-duration="1s" data-wow-delay="0.3s" data-wow-offset="0">
                                    <div style={{ margin: '30px 10px 30px 10px' }}>
                                        <h2 style={{ fontSize: '30px', lineHeight: "1.5", color:"white" }}>Feedback is vital for improvement</h2>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center clearfix">
                            <div className="col-lg-6 col-md-6 col-12 atf_home_img text-center">
                                <div className="atf-img-inner wow fadeInLeft" data-wow-duration="2s" data-wow-delay="0.4s" data-wow-offset="0">
                                    <div className="home-image-box">
                                        <div>
                                            <FontAwesomeIcon icon={faMobileAlt} style={{ color: 'var(--thm-color)', fontSize: '60px' }}></FontAwesomeIcon>
                                            <h3 className="shake-1">Kick</h3>
                                            <p>Kick in front of your phone camera</p>
                                        </div>
                                        <div>
                                            <FontAwesomeIcon icon={faRedo} className="loopSpinner"></FontAwesomeIcon>
                                        </div>
                                        <div>
                                            <FontAwesomeIcon icon={faLaptop} style={{ color: 'var(--thm-color)', fontSize: '40px', marginBottom: '5px' }}></FontAwesomeIcon>
                                            <FontAwesomeIcon icon={faTabletAlt} style={{ color: 'var(--thm-color)', fontSize: '60px', margin: '0px 20px 0 20px' }}></FontAwesomeIcon>
                                            <FontAwesomeIcon icon={faMobileAlt} style={{ color: 'var(--thm-color)', fontSize: '40px', margin: '0px 25px 5px 5px' }}></FontAwesomeIcon>
                                            <h3 className="shake-2">Watch. Learn. Improve</h3>
                                            <p>Watch replay instantly. On your phone, or a second device.</p>

                                            <p style={{ fontSize: "14px", margin: "30px 0 10px 0", lineHeight: "1.8", border: "2px solid yellowgreen", backgroundColor: "#F1F8E4", padding: "15px 0 15px 0", borderRadius: "10px" }}>
                                                PracticeLoop speeds up the <br /><span style={{fontSize:"16px"}}>Kick <FontAwesomeIcon icon={faArrowCircleRight}  style={{color:"yellowgreen"}}/> Watch <FontAwesomeIcon icon={faArrowCircleRight}  style={{color:"yellowgreen"}}/> Learn <FontAwesomeIcon icon={faArrowCircleRight}  style={{color:"yellowgreen"}}/> Improve</span><br /> cycle time.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>







                <section className="atf-section-padding" style={{ paddingTop: "40px", paddingBottom: "0px" }}>
                    <div className="container">
                        <div className="row justify-content-center" style={{backgroundColor: "yellowgreen"}}>
                            <div className="col-12 align-self-center text-center" style={{backgroundImage: 'url(assets/img/golf_collage.png)', backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                                <div style={{ margin: '20px 10px 20px 10px', padding: '10px', background:"white"}}>
                                    <h2 style={{ display: "inline-block", fontSize: '34px', lineHeight:"1.5", marginBottom: "10px", color:"var(--thm-black)",padding: "5px"}}>500+ App installs</h2><br />
                                    <h2 style={{ display: "inline-block", fontSize: '22px', marginBottom: "10px", lineHeight: "1.5", padding: "3px"}}>"Kids love it, and it really helps them improve."</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="batting_cricket" className="atf-about-area atf-section-padding atf-shape">
                    <img className="atf-shape-one" src="assets/img/shape/shape1.png" alt="" />
                    <div className="container">
                        <div className="row clearfix align-self-center">

                            <div className="col-xl-6 col-lg-6 col-12 align-self-center" style={{minHeight:"380px"}}>
                                <div className="atf-single-about-img text-center">
                                    <h2 style={{ margin: '30px 10px 0px 10px', fontSize: '26px' }}>
                                        Actively coach
                                    </h2>
                                    <p style={{fontSize:"16px"}} className="text-center my-auto">Use it as a tool to get your message across and show your young footballer what they should improve.</p>
                                    <img style={{marginTop: "35px"}} src="./assets/img/afl/actively_coach.png" alt="Actively coach" ></img>
                                </div>
                            </div>

                            <div className="col-xl-6 col-lg-6 col-12 align-self-center" style={{minHeight:"380px"}}>
                                <div className="atf-single-about-img text-center">
                                    <h2 style={{ margin: '30px 10px 0px 10px', fontSize: '26px' }}>
                                        Or let them go
                                    </h2>
                                    <p style={{fontSize:"16px"}} className="text-center my-auto">Just set it up and let them go.  They will spend hours not just practicing, but practicing correctly.</p>
                                    <img src="./assets/img/afl/let_them_go.png" alt="Let them go" style={{marginTop: "35px"}}></img>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>}
      />

    );
}
